
/* POLTZAA - Random cart bag recommendations */
(function () {
  'use strict';

  function shuffle(items) {
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  }

  function initUpsells(root = document) {
    root.querySelectorAll('[data-poltzaa-upsell]').forEach((section) => {
      if (section.dataset.poltzaaReady === 'true') return;

      section.dataset.poltzaaReady = 'true';

      const cards = Array.from(
        section.querySelectorAll('[data-poltzaa-upsell-card]')
      );

      shuffle(cards);

      cards.forEach((card, index) => {
        card.hidden = index >= 3;
        card.querySelectorAll('a, button').forEach((control) => {
          control.removeAttribute('tabindex');
        });
      });

      if (cards.length === 0) {
        section.hidden = true;
      } else {
        section.hidden = false;
      }
    });
  }

  function showMessage(section, message) {
    const output = section.querySelector('[data-poltzaa-upsell-message]');
    if (!output) return;

    output.textContent = message;
    output.hidden = false;
  }

  // Delegated listener remains available after Dawn refreshes the drawer.
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-poltzaa-upsell-add]');
    if (!button) return;

    event.preventDefault();

    if (button.disabled) return;

    const section = button.closest('[data-poltzaa-upsell]');
    const variantId = Number(button.dataset.variantId);
    const drawer = document.querySelector('cart-drawer');

    if (!variantId || !drawer) {
      showMessage(section, 'Unable to add this bag right now. Please try again.');
      return;
    }

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const response = await fetch(
        `${window.routes.cart_add_url}.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description || result.message || 'Could not add this bag.'
        );
      }

      if (
        result.sections &&
        result.sections['cart-drawer'] &&
        result.sections['cart-icon-bubble'] &&
        typeof drawer.renderContents === 'function'
      ) {
        drawer.renderContents(result);
      } else {
        // Safe fallback if Shopify doesn't return the expected sections.
        window.location.reload();
        return;
      }
    } catch (error) {
      console.error('POLTZAA cart upsell:', error);
      showMessage(
        section,
        error.message || 'Something went wrong. Please try again.'
      );

      button.disabled = false;
      button.textContent = originalText;
    }
  });

  // Initialize on page load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initUpsells());
  } else {
    initUpsells();
  }

  // Dawn replaces drawer HTML after cart updates, so initialize new cards.
  const observer = new MutationObserver(() => initUpsells());

  function startObserver() {
    if (!document.body) return;

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  }
})();


